module.exports = __webpack_public_path__ + "prod/1.42.2/img/huawei-icon.1f68708e.png";